import { useState } from 'react';
import { AppPhotosGrid } from '../../components/AppPhotosGrid';
import { AppPhotosPhoto } from '../../components/AppPhotosPhoto';
import { StyledContainer } from './PhonePhotos.styled';

const PhonePhotos = () => {
	const [isPhoto, setIsPhoto] = useState(false);

	return (
		<StyledContainer>
			{isPhoto ? (
				<AppPhotosPhoto setIsPhoto={setIsPhoto} />
			) : (
				<AppPhotosGrid setIsPhoto={setIsPhoto} />
			)}
		</StyledContainer>
	);
};

export { PhonePhotos };
